import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'

import { menuBtn } from '@/utils/menu_level2_button'
import {getMessageReviewById, setMessageReviewUserByMessageReviewId} from "@/api/message";
import {Loading} from "element-ui";

@Component({})
export default class HighSeasInfo extends Vue {
    culesInfoShow = false
    customerInfoShow = true
    operationShow = true
    id: number;
    infoData: any = ''
    // 跟进记录
    tableData = []
    page = 1
    limit = 20
    total = 0
    loading = false
    isReceive: any = ''
    informationListImg: any = []
    menuBtn = menuBtn
    activities = []
    types = ''
    type = ''
    status = ''
    logData = []
    dialog = false
    addSignShow = false
    transferShow = false
    approvalVisible = false
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    nodeType: string = null //驳回到哪个节点
    isSync: string = null //重新提交后触发E签宝/易快报
    approvedVisible = false // 审批通过
    approvedData = {
        isReturn: 1
    }
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    approvalStatus: number = null
    reviewIdea = '' // 审批意见
    reviewDialogShow = false // 审批意见弹框
    disBtn = false

    // created()
    created() {
        this.id = Number(this.$route.query.approval_id)
        this.type = this.$route.query.type ? this.$route.query.type as string : ''
        this.status = this.$route.query.status as string
        this.types = this.$route.query.types as string
        this.getInfoData()
    }

    // methods
    formatDate = formatDate

    async getInfoData() {
        const loading = this.$loading({
            lock: true,
            text: '正在加载',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

        const data: any = await getMessageReviewById(this.id,this.types)

        this.infoData = data.result
        this.logData = data.result.messageReviewLogList
        this.tableData = data.result.customerConversionFollowList
        setTimeout(() => {
            loading.close();
        }, 2000);
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }
    cancelApproval(){

    }


    //    驳回弹框确认
    doApprovalConfirm(data) {
        this.nodeType = data.rejectNode
        this.reviewIdea = data.reviewIdea
        this.isSync = data.isTouchE
        this.approvalVisible = false
        this.confirmReviewDialog()
    }

    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        this.reviewIdea = data.reviewIdea
        this.isAgreeRevoke = data.isAgreeRevoke
        this.approvedVisible = false
        this.approvedConfirm()
    }


    // 审批意见确认
    confirmReviewDialog() {
        const obj = {
            messageReviewId: this.id,
            status: this.approvalStatus,
            opinion: this.reviewIdea,
            form:  {},
            nodeType: this.nodeType,
        }
        this.disBtn = true;
        const loading = Loading.service({
            text: `审批${this.approvalStatus === 1 ? '通过中' : '驳回中'}，请稍后`
        })
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
            this.reviewIdea = ''
            this.reviewDialogShow = false
            loading.close();
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
            this.disBtn = false;
        })
    }

    approvedConfirm() {
        const obj = {
            messageReviewId: this.id,
            status: this.approvalStatus,
            opinion: this.reviewIdea,
            form:  {},
            isRevoke: this.isAgreeRevoke
        }
        this.disBtn = true;
        const loading = Loading.service({
            text: `审批${this.approvalStatus === 1 ? '通过中' : '驳回中'}，请稍后`
        })
        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
            this.reviewIdea = ''
            this.reviewDialogShow = false
            loading.close();
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
            this.disBtn = false;
        })
    }

    /*
    * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }
    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }


    // 驳回审批
    clickRejectButton(status: number) {
        this.approvalStatus = status
        this.approvalVisible = true
    }

    //通过审批
    clickExamineApproveButton(status: number) {
        this.approvalStatus = status
        this.approvedVisible = true
    }
}
